<template>
  <div>
    <Row type="flex" align="middle" style="margin: 20px 0">
      <Col>
        <Button type="primary" @click="changeModal(true)">发起补贴申报</Button>
      </Col>
      <Col style="color: #c5c8ce; margin: 0 0 0 20px">*申报完成后，帮扶积分将会清零，重新计算</Col>
    </Row>
    <Table ref="selection" :columns="columns" :data="data1">
      <template slot-scope="{ row }" slot="createdAt">
        {{ formatTime(row.createdAt) }}
      </template>
      <template slot-scope="{ row }" slot="status">
        {{ row.status === 1 ? '待处理' : row.status === 2 ? '已通过' : row.status === 3 ? '已完成' : '已拒绝' }}
      </template>
      <template slot-scope="{ row }" slot="union">
        {{ row.union && row.union.name }}
      </template>
      <template slot-scope="{ row }" slot="updatedAt">
        {{ row.status === 1 ? '-' : formatTime(row.updatedAt) }}
      </template>
    </Table>

    <div style="display: flex; align-items: center; margin-top: 20px">
      <span style="margin: 0 10px 0 0">总共{{ pagination.count }}个项目</span>
      <Page
        v-if="pagination.count"
        style="padding: 10px; background: #fff"
        class="page"
        @on-change="changePage"
        :current="pagination.pageIndex"
        :total="pagination.count"
        :page-size="pagination.pageSize"
        size="small"
        show-elevator
      />
    </div>

    <Modal v-model="modal" title="发起补贴申报" okText="发起申报" @on-ok="submitSubsidy" @on-cancel="changeModal(false)">
      <p style="color: #c5c8ce">本次申报积分：{{ total }}，申报完成后，帮扶积分将会清零，重新计算</p>
      <Row type="flex" justify="space-between" align="middle" style="font-size: 14px">
        <Col style="font-weight: bold; margin: 20px 0">申报材料</Col>
        <Col>
          <a>下载模板</a>
        </Col>
      </Row>
      <Row type="flex" align="middle" :gutter="10">
        <Col :span="4" style="text-align: right">入职证明：</Col>
        <Col :span="20">
          <Upload
            :headers="$uploader.headers()"
            :action="$uploader.action"
            :on-success="uploadSuccess1"
            :before-upload="$uploader.beforeUpload"
            :on-format-error="handleFormatError"
            :default-file-list="form.entryCerificate"
            :format="['doc', 'docx', 'pdf']"
          >
            <Button icon="ios-cloud-upload-outline">点击上传</Button>
          </Upload>
        </Col>
      </Row>
      <Row type="flex" align="middle" :gutter="10" style="padding: 10px 0">
        <Col style="text-align: right" :span="4">申请表：</Col>
        <Col :span="20">
          <Upload
            :headers="$uploader.headers()"
            :action="$uploader.action"
            :on-success="uploadSuccess2"
            :format="['doc', 'docx', 'pdf']"
            :on-format-error="handleFormatError"
            :before-upload="$uploader.beforeUpload"
            :default-file-list="form.applicationBlank"
          >
            <Button icon="ios-cloud-upload-outline">点击上传</Button>
          </Upload>
        </Col>
      </Row>
      <Row type="flex" align="middle" :gutter="10">
        <Col style="text-align: right" :span="4">承诺书：</Col>
        <Col :span="20">
          <Upload
            :headers="$uploader.headers()"
            :action="$uploader.action"
            :on-success="uploadSuccess3"
            :format="['doc', 'docx', 'pdf']"
            :on-format-error="handleFormatError"
            :before-upload="$uploader.beforeUpload"
            :default-file-list="form.letterOfCommitment"
          >
            <Button icon="ios-cloud-upload-outline">点击上传</Button>
          </Upload>
        </Col>
      </Row>
    </Modal>
  </div>
</template>
<script>
export default {
  props: {
    planId: String
  },
  data() {
    return {
      modal: false,
      columns: [
        {
          title: '申报时间',
          key: 'createdAt',
          slot: 'createdAt'
        },
        {
          title: '申报积分',
          key: 'score'
        },
        {
          title: '申报状态',
          key: 'status',
          slot: 'status'
        },
        {
          title: '申报工会',
          key: 'union',
          slot: 'union'
        },
        {
          title: '完成时间',
          key: 'updatedAt',
          slot: 'updatedAt'
        }
      ],
      data1: [],
      pagination: {},
      form: {
        entryCerificate: [],
        applicationBlank: [],
        letterOfCommitment: []
      },
      total: 0
    };
  },
  watch: {
    planId: {
      deep: true,
      handler(newVal) {
        this.getTotal();
        this.helpDeclare()
      }
    }
  },
  methods: {
    getTotal() {
      this.$axios
        .request({
          url: 'front/v1/company/help-plan-score/total',
          method: 'get',
          params: { planId: this.planId }
        })
        .then(res => {
          this.total = res.data.score || 0;
        });
    },
    helpDeclare(page = 1) {
      this.$axios
        .request({
          url: 'front/v1/help-company-declare/own',
          method: 'get',
          params: { pageIndex: page, planId: this.planId }
        })
        .then(res => {
          this.data1 = res.data.list || [];
          this.pagination = { count: res.data.count, pageIndex: res.data.pageIndex, pageSize: res.data.pageSize };
        });
    },
    changePage(page) {
      this.helpDeclare(page);
    },
    uploadSuccess1(res) {
      this.$set(this.form, 'entryCerificate', []);
      this.form.entryCerificate.push({
        url: res.data.url,
        name: res.data.name
      });
    },
    uploadSuccess2(res) {
      this.$set(this.form, 'applicationBlank', []);
      this.form.applicationBlank.push({
        url: res.data.url,
        name: res.data.name
      });
    },
    uploadSuccess3(res) {
      this.$set(this.form, 'letterOfCommitment', []);
      this.form.letterOfCommitment.push({
        url: res.data.url,
        name: res.data.name
      });
    },

    handleFormatError(file) {
      this.$Notice.warning({
        title: '文件格式不对',
        desc: '需上传doc, docx, pdf格式文件'
      });
    },
    submitSubsidy() {
      this.$axios
        .request({
          url: 'front/v1/help-company-declare',
          method: 'post',
          data: {
            planId: parseInt(this.planId),
            entryCertificate: this.form.entryCerificate.length
              ? { name: this.form.entryCerificate[0].name, url: this.form.entryCerificate[0].url }
              : undefined,
            applicationBlank: this.form.applicationBlank.length
              ? { name: this.form.applicationBlank[0].name, url: this.form.applicationBlank[0].url }
              : undefined,
            letterOfCommitment: this.form.letterOfCommitment.length
              ? { name: this.form.letterOfCommitment[0].name, url: this.form.letterOfCommitment[0].url }
              : undefined
          }
        })
        .then(res => {
          if (res.msg === '帮扶积分不足') {
            this.$Modal.info({
              title: '帮扶积分不足',
              content: `当前帮扶积分：${this.total}`,
              okText: '知道了'
            });
          } else {
            this.$Notice.success({
              title: '申报成功'
            });
            this.getTotal();
            this.helpDeclare();
          }
        });
    },
    changeModal(status = false) {
      this.modal = status;
      this.form = {
        entryCerificate: [],
        applicationBlank: [],
        letterOfCommitment: []
      };
    }
  }
};
</script>
<style scoped lang="less">
::v-deep .ivu-upload {
  display: flex;
}
::v-deep .ivu-upload-list {
  margin-left: 20px;
}
::v-deep .ivu-btn {
  height: 34px !important;
}
</style>
